import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import { FormBox } from '../../../css';

const MultiCheckboxField = ({
  label,
  errors,
  touched,
  name,
  defaultVal,
  list,
  errorIcon,
  val,
  setFieldValue,
  setFieldTouched
}) => {
  const initialOptions = list.map(item => ({
    ...item,
    checked: defaultVal && defaultVal.includes(item.id)
  }));
  const [allOptions, setAllOptions] = useState(initialOptions);
  const onChange = ({ target: { value, checked } }) => {
    const newOptions = allOptions.map(item => ({
      ...item,
      checked: item.id === value ? checked : item.checked
    }));
    setAllOptions(newOptions);

    setFieldValue(newOptions.filter(item => item.checked).map(item => item.id));
    setFieldTouched();
  };

  return (
    <FormBox>
      <div className="main-content-form-headers">
        <span>{label}</span>
      </div>
      <div
        style={{ position: 'relative', width: '100%' }}
        className={`color-light input-container ${errors[name] && touched[name] ? 'error' : ''
          }`}
      >
        {allOptions.map(l => (
          <div key={l.name}>
            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            {l.name !== '' ?
              <label htmlFor={l.name}>
                <Field
                  type="checkbox"
                  id={l.name}
                  name={l.name}
                  value={l.id}
                  checked={l.checked}
                  onChange={onChange}
                />
                {` ${l[val]}`}
              </label> : ''}
          </div>
        ))}
        <>
          <div className="error_messages">
            <span className="registration-error">{errors[name]}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={errorIcon} alt="error_icon" />
          </div>
        </>
      </div>
    </FormBox>
  );
};

MultiCheckboxField.propTypes = {
  label: PropTypes.string.isRequired,
  errors: PropTypes.objectOf(PropTypes.string),
  touched: PropTypes.objectOf(PropTypes.bool),
  name: PropTypes.string.isRequired,
  defaultVal: PropTypes.arrayOf(PropTypes.any),
  errorIcon: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.any).isRequired,
  val: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired
};

MultiCheckboxField.defaultProps = {
  errors: {},
  touched: {},
  defaultVal: null,
  errorIcon: null
};

export default MultiCheckboxField;
